import React from "react";
import {
  Space,
  Table,
  Pagination,
  Image,
  Switch,
  Spin,
  Button,
  Input,
  notification,
  Radio,
} from "antd";
import { SearchOutlined, FilterOutlined } from "@ant-design/icons";
import cookie from "react-cookies";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import { Link, useLocation, useNavigate } from "react-router-dom";
// scroll Top
const useScroll = () => {
  const myRef = useRef(null);
  const executeScroll = () => myRef.current.scrollIntoView();
  return [executeScroll, myRef];
};
const Usertable = () => {
  /* Navigation and Location to use for page switching and getting specific page url */
  const navigate = useNavigate();
  const location = useLocation();
  /* Query Params to get from URL */
  const queryParams = new URLSearchParams(location.search);
  const pageParams = queryParams.get("page");
  const emailParams = queryParams.get("email");
  const genderParams = queryParams.get("gender");
  const addressParams = queryParams.get("address");
  const phoneParams = queryParams.get("phone");
  const isActiveParams = queryParams.get("is_active");
  /* Local States to save data */
  const [searchByParams, setSearchByParams] = useState("");
  const [userData, setUserData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [executeScroll, myRef] = useScroll();
  const [checkedList, setCheckedList] = useState("");
  const [isActiveCheckedList, setIsActiveCheckedList] = useState("");
  const [selectedFilters, setSelectedFilters] = useState({});
  const searchInput = useRef(null);

  // notification handler
  const openNotification = (message, description) => {
    notification.open({
      message: message,
      description: description,
    });
  };

  // method for API call
  const getUserHandler = (page, searchByParams) => {
    setLoader(true);
    // login token
    const token = cookie.load("token");
    const config = {
      headers: { Authorization: `Bearer ${JSON.parse(token)}` },
    };
    // queryString to check any filter option is selected or not
    let payload = "";
    if (searchByParams && searchByParams?.name) {
      payload = `&first_name=${searchByParams?.name}`;
    }
    if (searchByParams && searchByParams?.email) {
      payload = payload + `&email=${searchByParams?.email}`;
    }
    if (searchByParams && searchByParams?.address) {
      payload = payload + `&city=${searchByParams?.address}`;
    }
    if (searchByParams && searchByParams?.gender) {
      payload = payload + `&gender=${searchByParams?.gender}`;
    }
    if (searchByParams && searchByParams?.phone) {
      payload = payload + `&phone=${searchByParams?.phone}`;
    }
    if (searchByParams && searchByParams?.is_active) {
      payload = payload + `&is_active=${searchByParams?.is_active}`;
    }
    //axios call
    axios
      .get(
        `${process.env.REACT_APP_FRONTED_URL}/users?locale=en&page=${page}&role=Normal User${payload}`,
        config
      )
      .then((response) => {
        setUserData(response?.data?.data);
        setLoader(false);
      })
      .catch((error) => {
        setLoader(false);
        console.log(error);
      });
  };

  // handler to search data from using using specific key (name,address)
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    // if not empty and same object is entered
    let searched = searchByParams
      ? {
          ...searchByParams,
          [dataIndex]: dataIndex !== "gender" ? selectedKeys[0] : selectedKeys,
        }
      : {
          [dataIndex]: dataIndex !== "gender" ? selectedKeys[0] : selectedKeys,
        };
    setSearchByParams(searched);
    navigate(
      `/users?page=${1}${searched?.email ? `&email=${searched?.email}` : ""}${
        searched?.address ? `&address=${searched?.address}` : ""
      }${searched?.gender ? `&gender=${searched?.gender}` : ""}${
        searched?.phone ? `&phone=${searched?.phone}` : ""
      }${searched?.is_active ? `&is_active=${searched?.is_active}` : ""}`
    );
    // API CALL
    getUserHandler(1, searched);
    setCurrentPage(1);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchByParams("");
    setCheckedList("");
    getUserHandler(1, {});
    setCurrentPage(1);
    setSelectedFilters({});
    navigate(`/users?page=${1}`);
  };

  // handler for name , address
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedFilters[dataIndex]}
          onChange={(e) => {
            setSelectedKeys(e.target.value ? [e.target.value] : []);
            setSelectedFilters({
              ...selectedFilters,
              [dataIndex]: e.target.value,
            });
          }}
          onPressEnter={() => {
            handleSearch(selectedKeys, confirm, dataIndex);
            close();
          }}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => {
              handleSearch(selectedKeys, confirm, dataIndex);
              close();
            }}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters);
              setSelectedKeys("");
              close();
            }}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
              setIsActiveCheckedList("");
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : "#666",
        }}
      />
    ),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  // handle for checkbox
  const onChange = (e) => {
    setCheckedList(e.target.value);
    setSelectedFilters({ ...selectedFilters, gender: e.target.value });
  };

  // handler for gender , kyc verification
  const getColumnSelectedProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, confirm, clearFilters, close }) =>
      dataIndex === "gender" ? (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <div className="gender-head">
            <h4>Gender Details</h4>
          </div>
          <div className="gender-check">
            <Radio.Group onChange={onChange} value={selectedFilters?.gender}>
              <Radio value={"Male"}>Male</Radio>
              <Radio value={"Female"}>Female</Radio>
              <Radio value={"Other"}>Other</Radio>
            </Radio.Group>
          </div>
          <Space>
            <Button
              type="primary"
              onClick={() => {
                handleSearch(checkedList, confirm, dataIndex);
                close();
              }}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              Search
            </Button>
            <Button
              onClick={() => {
                clearFilters && handleReset(clearFilters);
                setSelectedKeys("");
                close();
              }}
              size="small"
              style={{
                width: 90,
              }}
            >
              Reset
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                close();
                setCheckedList("");
              }}
            >
              close
            </Button>
          </Space>
        </div>
      ) : (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <div className="gender-head">
            <h4>KYC Verification</h4>
          </div>
          <div className="gender-check">
            <Radio.Group
              onChange={(e) => {
                setIsActiveCheckedList(e.target.value);
                setSelectedFilters({
                  ...selectedFilters,
                  is_active: e.target.value,
                });
              }}
              value={selectedFilters?.is_active}
            >
              <Radio value={"1"}>Active</Radio>
              <Radio value={"0"}>Deactive</Radio>
            </Radio.Group>
          </div>
          <Space>
            <Button
              type="primary"
              onClick={() => {
                handleSearch(isActiveCheckedList, confirm, dataIndex);
                close();
              }}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              Search
            </Button>
            <Button
              onClick={() => {
                clearFilters && handleReset(clearFilters);
                setSelectedKeys("");
                close();
              }}
              size="small"
              style={{
                width: 90,
              }}
            >
              Reset
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                close();
                setCheckedList("");
              }}
            >
              close
            </Button>
          </Space>
        </div>
      ),
    filterIcon: (filtered) => (
      <FilterOutlined
        style={{
          color: filtered ? "#1677ff" : "#666",
        }}
      />
    ),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput?.current?.select(), 100);
      }
    },
  });

  //  API for user
  useEffect(() => {
    let paramsPayload = {};
    if (
      emailParams ||
      addressParams ||
      genderParams ||
      phoneParams ||
      isActiveParams
    ) {
      paramsPayload = {
        email: emailParams,
        address: addressParams,
        gender: genderParams,
        phone: phoneParams,
        is_active: isActiveParams,
      };
    }
    setSearchByParams(paramsPayload);
    setSelectedFilters(paramsPayload);
    getUserHandler(pageParams ? pageParams : 1, paramsPayload);
    setCurrentPage(pageParams ? parseInt(pageParams) : 1);
    // eslint-disable-next-line
  }, []);

  //handler to active or Deactive user
  const kycHandler = (value) => {
    setSelectedUserId(value?.id);
    const token = cookie.load("token");
    const config = {
      headers: { Authorization: `Bearer ${JSON.parse(token)}` },
    };
    //axios call
    axios
      .get(
        `${process.env.REACT_APP_FRONTED_URL}/user-activation?locale=en&user_id=${value?.id}`,
        config
      )
      .then((response) => {
        setSelectedUserId("");
        openNotification("Success", response?.data?.message);
        let duplicateData = [...userData?.data];
        duplicateData?.forEach((item, index) => {
          if (item?.id === value?.id) {
            return (duplicateData[index].is_active =
              value.is_active === 1 ? 0 : 1);
          }
        });
        setUserData({ ...userData, data: duplicateData });
      })
      .catch((error) => {
        setSelectedUserId("");
        openNotification("Error", "");
      });
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "",
      key: "profile",
      render: (data) => (
        <div>
          <Image
            width={50}
            height={50}
            style={{ borderRadius: "50%" }}
            src="error"
            fallback={
              data?.profile_photo !== null && data?.profile_photo !== ""
                ? data?.profile_photo
                : "data:image/png;base64,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"
            }
          />
          <Space size="middle" style={{ padding: "0px 10px" }}>
            {data?.first_name + " " + data?.last_name}
          </Space>
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      ...getColumnSearchProps("email"),
    },
    {
      title: "Address",
      dataIndex: "preferences",
      key: "",
      render: (data) => (
        <Space size="middle">
          <Space size="middle">{data?.city_of_residence || "-"}</Space>
        </Space>
      ),
      ...getColumnSearchProps("address"),
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      ...getColumnSelectedProps("gender"),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "",
      ...getColumnSearchProps("phone"),
      render: (data) => (
        <Space size="middle">{data === null ? "-" : data}</Space>
      ),
    },
    {
      title: "Active/Deactive",
      key: "action",
      ...getColumnSelectedProps("is_active"),
      render: (data, index) => (
        <Space size="middle">
          {data?.id === selectedUserId ? (
            <Spin />
          ) : (
            <Switch
              checkedChildren="on"
              unCheckedChildren="off"
              checked={data?.is_active === 1 ? true : false}
              onChange={() => kycHandler(data)}
            />
          )}
        </Space>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (data) => (
        <Link to={`/user-detail/${data?.id}`}>View Details</Link>
      ),
    },
  ];

  return (
    <React.Fragment>
      <Helmet>
        <title>4EVERINLOVE - USERS</title>
        <meta name="description" content="4everinlove Users" />
      </Helmet>
      <div ref={myRef}>
        <div className="header" style={{ paddingBottom: "15px" }}>
          <h3>All Users</h3>
        </div>
        <div>
          <Table
            columns={columns}
            dataSource={userData?.data}
            loading={loader}
            pagination={false}
            scroll={{ x: 1023 }}
          />
          {/* Pagination */}
          <Pagination
            defaultPageSize={currentPage}
            showSizeChanger={false}
            current={currentPage}
            pageSize={
              userData !== undefined && userData?.length !== 0
                ? userData?.per_page
                : 1
            }
            total={userData?.total}
            onChange={(e) => {
              setCurrentPage(e);
              getUserHandler(e, searchByParams);
              executeScroll();
              navigate(
                `/users?page=${e}${
                  searchByParams?.email ? `&email=${searchByParams?.email}` : ""
                }${
                  searchByParams?.gender
                    ? `&gender=${searchByParams?.gender}`
                    : ""
                }${
                  searchByParams?.address
                    ? `&address=${searchByParams?.address}`
                    : ""
                }${
                  searchByParams?.phone ? `&phone=${searchByParams?.phone}` : ""
                }${
                  searchByParams?.is_active
                    ? `&is_active=${searchByParams?.is_active}`
                    : ""
                }
              `
              );
            }}
            className="pagination"
          />
        </div>
      </div>
    </React.Fragment>
  );
};
export default Usertable;
